const WHATSAPP_NUMBER = "5555991438702";
export const WHATSAPP_DEFAULT_MESSAGE =
  "Olá, estou procurando uma dedetizadora em Chapecó e gostaria de fazer um orçamento";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_DEFAULT_MESSAGE,
)}`;

export const SITE = {
  name: "Dedetizadora em Chapecó",
  shortName: "Dedetizadora Chapecó",
  tagline: "Controle profissional de pragas urbanas em Chapecó e região oeste de Santa Catarina",
  description:
    "Dedetizadora em Chapecó especializada no controle de baratas, formigas, ratos, cupins, aranhas e escorpiões. Atendimento residencial, comercial e industrial com equipe técnica, produtos registrados e garantia de serviço.",
  baseUrl: "https://dedetizadorachapeco.com.br",
  email: "contato@dedetizadorachapeco.com.br",
  phone: "(55) 9 9143-8702",
  whatsapp: WHATSAPP_NUMBER,
  whatsappMessage: WHATSAPP_DEFAULT_MESSAGE,
  whatsappUrl: WHATSAPP_URL,
  address: "Rua Osvaldo Aranha, Centro — Chapecó/SC",
  hours: "Seg a Sex 8h–18h · Sáb 8h–12h · Emergências 24h",
  social: {
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
    whatsapp: WHATSAPP_URL,
  },
};

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/servicos", label: "Serviços" },
  { to: "/locais", label: "Áreas de atendimento" },
  { to: "/blog", label: "Blog" },
  { to: "/sobre", label: "Sobre" },
  { to: "/equipe", label: "Equipe" },
  { to: "/contato", label: "Contato" },
] as const;
